'use client';

import { type ReactElement, type ReactNode } from 'react';
import { cn } from '@/lib/utils';

export type BurgerMenuNavigationDirection = 'forward' | 'back';

type BurgerMenuNavigationLevelProps = {
    /** Stable key for the current navigation depth (e.g. category path or `root`). */
    levelKey: string;
    /** When set, the panel slides in from the right (forward) or left (back). */
    direction: BurgerMenuNavigationDirection | null;
    children: ReactNode;
};

/**
 * Wraps burger menu level content (trending carousel and navigation) and animates level changes horizontally.
 */
export const BurgerMenuNavigationLevel = ({
    levelKey,
    direction,
    children,
}: BurgerMenuNavigationLevelProps): ReactElement => {
    return (
        <div className="overflow-x-hidden overflow-y-visible">
            <div
                key={levelKey}
                className={cn(
                    direction && 'animate-in fill-mode-both duration-300 ease-out motion-reduce:animate-none',
                    direction === 'forward' && 'fade-in-0 slide-in-from-right',
                    direction === 'back' && 'fade-in-0 slide-in-from-left'
                )}>
                {children}
            </div>
        </div>
    );
};
